import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-100">
      <div className="px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                  <i className="ri-play-fill text-background-50 text-lg w-4 h-4 flex items-center justify-center"></i>
                </div>
                <span className="font-heading text-xl font-semibold text-background-50">麻豆视频</span>
              </div>
              <p className="text-sm text-foreground-400 leading-relaxed">
                麻豆视频是备受关注的原创高清内容平台，致力于为用户提供丰富优质的影视娱乐资源和极致的观看体验。
              </p>
            </div>

            <div>
              <h4 className="font-heading text-base font-semibold text-background-50 mb-4">快速链接</h4>
              <ul className="space-y-2.5">
                <li><Link to="/" className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer">首页</Link></li>
                <li><Link to="/category/drama" className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer">分类浏览</Link></li>
                <li><Link to="/about" className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer">关于我们</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-base font-semibold text-background-50 mb-4">内容分类</h4>
              <ul className="space-y-2.5">
                <li><Link to="/category/drama" className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer">剧情大片</Link></li>
                <li><Link to="/category/comedy" className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer">喜剧综艺</Link></li>
                <li><Link to="/category/documentary" className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer">纪录纪实</Link></li>
                <li><Link to="/category/music" className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer">音乐现场</Link></li>
                <li><Link to="/category/lifestyle" className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer">生活时尚</Link></li>
                <li><Link to="/category/tech" className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer">科技数码</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-base font-semibold text-background-50 mb-4">联系方式</h4>
              <ul className="space-y-2.5">
                <li className="flex items-center gap-2 text-sm text-foreground-400">
                  <span className="w-4 h-4 flex items-center justify-center"><i className="ri-mail-line text-sm w-3.5 h-3.5 flex items-center justify-center"></i></span>
                  contact@zhxnfyygl.cn
                </li>
                <li className="flex items-center gap-2 text-sm text-foreground-400">
                  <span className="w-4 h-4 flex items-center justify-center"><i className="ri-customer-service-2-line text-sm w-3.5 h-3.5 flex items-center justify-center"></i></span>
                  客服热线：400-888-8888
                </li>
                <li className="flex items-center gap-2 text-sm text-foreground-400">
                  <span className="w-4 h-4 flex items-center justify-center"><i className="ri-map-pin-line text-sm w-3.5 h-3.5 flex items-center justify-center"></i></span>
                  北京市朝阳区科技园区
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-background-800/50 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              &copy; 2026 麻豆视频 版权所有 | 京ICP备XXXXXXXX号
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-foreground-500 hover:text-background-50 transition-colors" rel="nofollow">隐私政策</a>
              <a href="#" className="text-xs text-foreground-500 hover:text-background-50 transition-colors" rel="nofollow">用户协议</a>
              <a href="#" className="text-xs text-foreground-500 hover:text-background-50 transition-colors" rel="nofollow">版权声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}